import { enumObjectTypes, enumSubChartFlag, enumBranchStyle } from "../constants";

export class QSCNode {
  constructor() {
    this.fSCM = null;
    //   this.fSCNodeID = null;
    this.fLayout = null;
    this.fDataObj = null;
    this.fDataObjID = null;
  }

  InitSCNode(layout, dataObj, dataObjID, subChartMgr) {
    this.fLayout = layout;
    this.fDataObj = dataObj;
    this.fDataObjID = dataObjID;
    this.fSCM = subChartMgr;
  }

  SetSubChartMgr(subChartMgr) {
    this.fSCM = subChartMgr;
  }

  GetSubChartMgr() {
    return this.fSCM;
  }

  JournalLayoutChg() {
    this.fSCM.JournalLayoutChg(this.fLayout);
  }

  SetPositionRef(positionObj) {
    this.fPositionDataObj = positionObj;
  }

  GetPositionRef() {
    return this.fPositionDataObj;
  }

  GetDataObj() {
    return this.fDataObj;
  }

  GetDataObjID() {
    return this.fDataObjID;
  }

  GetLayout() {
    return this.fLayout;
  }

  GetSubChartID() {
    var l = this.fLayout;
    return l.GetSubChartID();
  }

  IsPositionSCNode() {
    const dataObj = this.GetDataObj();
    if (dataObj == null) return false;
    return dataObj.IsPositionObj();
  }

  IsHolderSCNode() {
    const dataObj = this.GetDataObj();
    if (dataObj == null) return false;
    return dataObj.IsHolderObj();
  }

  RemoveFieldReferences(fieldRefList, updateRef = false) {
    var l = this.fLayout;
    return l.RemoveFieldReferences(fieldRefList, updateRef);
  }

  GetBranchStyle() {
    var l = this.fLayout;
    return l.GetBranchStyle();
  }

  SetBranchStyle(branchStyle) {
    var l = this.fLayout;
    return l.SetBranchStyle(branchStyle);
  }

  IsAssistant() {
    var l = this.fLayout;
    return l.IsAssistant();
  }

  GetLayoutBottom() {
    var l = this.fLayout;
    return l.GetLayoutBottom();
  }

  GetLayoutTop() {
    var l = this.fLayout;
    return l.GetLayoutTop();
  }

  AddToTopSpacing(topSpacing) {
    var l = this.fLayout;
    return l.AddToTopSpacing(topSpacing);
  }

  TopOfBreak() {
    var l = this.fLayout;
    var scFlag = l.GetSubChartFlag();
    if (scFlag == enumSubChartFlag.drilldown) return true;

    return false;
  }

  BottomOfBreak() {
    var l = this.fLayout;
    var scFlag = l.GetSubChartFlag();
    if (scFlag == enumSubChartFlag.drillup) return true;

    return false;
  }

  IsTopOfSubChart() {
    const dataObj = this.GetDataObj();
    const isScBreakBottom = this.BottomOfBreak();
    const isOrphan = dataObj?.GetParent() == null;

    return isScBreakBottom || isOrphan;
  }

  GetSubChartFlag() {
    var l = this.fLayout;
    var scFlag = l.GetSubChartFlag();

    return scFlag;
  }

  LockLayout(lockLayout) {
    var l = this.fLayout;
    l.SetLockFlag(lockLayout);
  }

  IsLayoutLocked() {
    var l = this.fLayout;
    var lockFlag = l.GetLockFlag();
    var isLocked = lockFlag == 1;

    return isLocked;
  }

  UpdateAssociatedChildrenIDs(aNode) {
    var layout = this.GetLayout();

    var numChildren = aNode.GetNumChildren();
    for (var i = 0; i < numChildren; i++) {
      var child = aNode.GetIndexChild(i);
      layout.AddAssociatedChildID(child.GetObjectID());
    }
  }

  RemoveAssociateChildrenIDs(aNode) {
    var layout = this.GetLayout();
    var dbObj = aNode.GetDataObj();
    var numChildren = dbObj.GetNumChildren();
    for (var i = 0; i < numChildren; i++) {
      var child = dbObj.GetIndexChild(i);
      layout.RemoveAssociatedChildID(child.GetObjectID());
    }
  }

  GetNumChildren() {
    var dataObj = this.GetDataObj();
    if (dataObj == null) return 0;

    var scFlag = this.GetSubChartFlag();
    if (scFlag == enumSubChartFlag.drilldown) return 0;

    var l = this.GetLayout();
    var isCollapsed = l.GetCollapsed();
    if (isCollapsed) return 0;

    if (this.GetBranchStyle() === enumBranchStyle.index) return 0;

    return dataObj.GetNumChildren();
  }

  /**
   * Move a box to a different subchart. If we have holders, we move those too. The node will be removed from the SubChart.
   * @param {QSCNode} node - The node to move.
   * @param {string} targetSCID - The ID of the target subchart.
   */
  MoveSCNodeToSubChart(targetSCID) {
    const cursubchartID = this.GetSubChartID();
    const scm = this.GetSubChartMgr();
    const dataObj = this.GetDataObj();

    this.GetLayout().SetSubChartID(targetSCID);
    scm.RemoveSCNode(dataObj?.GetObjectID(), cursubchartID);

    this.GetDataObj()
      ?.GetHolderList()
      ?.forEach(holder =>
        scm.FindSCNode(holder, cursubchartID)?.GetLayout().SetSubChartID(targetSCID)
      );
  }
}
